// extracted by mini-css-extract-plugin
export default {"container":"er-z","brandName":"fr-z","productName":"gr-z","productNamePdpEnhancements":"hr-z","breakLongProductName":"ir-z"};